import React from "react";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  items?: FaqItem[];
}

export const FaqSection: React.FC<FaqSectionProps> = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const middle = Math.ceil(items.length / 2);
  const leftItems = items.slice(0, middle);
  const rightItems = items.slice(middle);

  const renderItems = (columnItems: FaqItem[], openFirst: boolean): React.ReactElement => (
    <div>
      {columnItems.map((item, index) => (
        <details key={item.question} className="group border-b border-border py-1" open={openFirst && index === 0}>
          <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-4 font-medium marker:content-none [&::-webkit-details-marker]:hidden">
            {item.question}
            <span className="shrink-0 text-xl text-muted-foreground transition-transform group-open:rotate-45">+</span>
          </summary>
          <p className="pb-5 text-muted-foreground">{item.answer}</p>
        </details>
      ))}
    </div>
  );

  return (
    <section className="bg-background py-16 md:py-24">
      <div className="container px-4 md:px-6">
        <div className="mb-10">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-muted-foreground">Частые вопросы</p>
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">Коротко и по делу</h2>
        </div>

        <div className="grid grid-cols-1 gap-x-12 md:grid-cols-2">
          {renderItems(leftItems, true)}
          {renderItems(rightItems, false)}
        </div>
      </div>
    </section>
  );
};
